// extracted by mini-css-extract-plugin
module.exports = {"root":"header-nav-items_root__El1Ki","item":"header-nav-items_item__993or","active":"header-nav-items_active__7NYsZ","compact":"header-nav-items_compact__iRJpQ"};